import '../../css/chat/message.css';
import React, { useEffect } from 'react';
import Moment from 'react-moment';
import { hourFormat } from '../utils/consts';
import { useTranslation } from 'react-i18next';
import ChannelIcon from './channelIcon';
function Message(props) {

    const { t } = useTranslation();

    useEffect(() => {
        return () => {
            // component unmounts
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.message]);

    const renderIcon = () => {
        let icon = <div className={`user-icon`} style={props.image != null && props.image.trim() !== "" ? { backgroundImage: `url(${props.image})` } : {}}>
            {
                !props.image &&
                <ChannelIcon channel={props.channel} />
            }
        </div>;


        if (props.type === "A") {
            let usrImgPath = `//${props.photo}`;

            if (props.isHistory)
                usrImgPath = this.props.image;

            icon = <div className="user-img-chat"
                style={props.photo != null && props.photo.trim() !== "" ? { backgroundImage: `url(${usrImgPath})` } : {}}
            ></div>;
        };

        return icon;
    };

    const renderSenderName = () => {
        return <div className={props.type === "A" ? "agent-name text-muted" : "user-name text-muted"}>{props.senderName || t("client")}</div>;
    }

    const renderTime = () => {
        return <div className={props.type === "A" ? "agent-time" : "user-time"}><Moment format={hourFormat}>{new Date(props.date)}</Moment></div>
    }

    const renderMessage = () => {
        let text = "";

        if ((props.text != null && props.text.length > 0) || props.media) {
            text = props.text;

            if (props.searchText && props.text.toLowerCase().indexOf(props.searchText) >= 0) {
                text = text.replace(new RegExp("<mark>", 'g'), "");
                text = text.replace(new RegExp("</mark>", 'g'), "");
                text = text.replace(new RegExp(props.searchText + "(?=[^]*)", "ig"), "<mark>$&</mark>");
            }

        }

        let message = <div className={props.type === "A" ? "agent-message" : "user-message badge-light-primary"} dangerouslySetInnerHTML={{ __html: text }}></div>;
        if (props.media) {

            let mediaElement = null,
                url = "",
                opts = <></>;

            if (props.url)
                url = !props.url.startsWith("http") ? `${props.chatUrl}/${props.url}` : props.url;

            switch (props.mediaType) {
                case "image":
                    mediaElement = <img src={url} width="100%" alt={text} title={text} />;
                    break;
                case "video":
                    mediaElement = <video src={url} width="100%" controls={true} />;
                    break;
                case "audio":
                case "voice":
                    mediaElement = <audio src={url} width="100%" controls={true} />;
                    break;
                case "document":
                case "file":
                    if (url.indexOf(".pdf") > -1) {
                        mediaElement = <embed src={url} width="100%"></embed>;
                    }
                    break;
                case "options":
                    var textTokens = text.split("<br/>");
                    if (textTokens.length > 1) {
                        text = textTokens[0];
                    }
                    break;
                default:

            }

            if (props.mediaType === "options") {
                opts = <div className="sys-opts" dangerouslySetInnerHTML={{ __html: textTokens[1] }}></div>
            }
            message = <>
                <div className={props.type === "A" ? "agent-message" : "user-message badge-light-primary"} >
                    <a href={url} target="_blank" rel="noopener noreferrer">{mediaElement}
                        <div dangerouslySetInnerHTML={{ __html: text }}></div>
                    </a>
                </div>
                {opts}
            </>;


        }

        return message;
    }

    return (<>
        {
            ((props.text != null && props.text.length > 0) || props.media) &&
            <div className='message' ref={props.childref} id={props.id}>
                {renderIcon()}
                {renderSenderName()}
                {renderTime()}
                {renderMessage()}
                {
                    props.reference &&
                    <></>
                }
            </div>
        }
    </>

    );
}

export default Message;